//TODO: Hook up academy specific activecampaign when completed + update tests
import React, { useState } from "react"
import ActiveCampaignWidget from "../../active-campaign-widget/activeCampaignWidget"
import { BellIcon, NewExitIcon } from "../../../modules/Icons"

export const containerClass = "flex flex-col items-center mx-6 my-12 gap-4 lg:mx-auto lg:my-auto lg:gap-5 max-w-[680px]"
export const headerTextClass = "font-bold leading-9 uppercase eurostile text-20 lg:text-28"
export const textClass = "lg:leading-[30px] text-center text-14 lg:text-18 text-a-light-gray"
export const buttonsContainerClass = "cursor-pointer bg-[#1F3D48] whitespace-nowrap bg-opacity-70 rounded-[5px] px-6 lg:px-[30px] py-4 uppercase text-a-blue w-fit eurostile font-bold text-12 lg:text-17 tracking-wider lg:leading-24 stroke-a-blue hover:bg-[#114C63] hover:text-white hover:stroke-white"
export const bellIconClass = "inline mr-[10px]"

export const modalOverlayClass = "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
export const modalContentClass = "bg-a-dark-gray rounded-lg p-6 max-w-sm w-full mx-4 relative"
export const closeButtonClass = "absolute top-4 right-4 text-gray-500 hover:text-gray-700 cursor-pointer text-xl font-bold w-6 h-6 flex items-center justify-center"
export const iconClass = "stroke-a-light-gray"

const CoursesComingSoon: React.FC<{}> = () => {
  const [showWidget, setShowWidget] = useState(false)

  const closeModal = () => {
    setShowWidget(false)
  }

  return (
    <>
      <div cy-test-id="courses-coming-soon" className={containerClass}>
        <div className={headerTextClass}>courses are on the way</div>
        <div className={textClass}>Our instructors are hard at work behind the scenes designing courses that will help you level up your VFX skills.</div>
        <div className={buttonsContainerClass} onClick={() => setShowWidget(true)}>
          <BellIcon className={bellIconClass} />
          notify me when courses drop
        </div>
      </div>
      {showWidget && (
        <div className={modalOverlayClass} onClick={closeModal}>
          <div className={modalContentClass} onClick={(e) => e.stopPropagation()}>
            <button
              className={closeButtonClass}
              onClick={closeModal}
              aria-label="Close modal"
            >
              <NewExitIcon className={iconClass} />
            </button>
            <ActiveCampaignWidget />
          </div>
        </div>
      )}
    </>
  )
}

export default CoursesComingSoon